import { CircleAlert as AlertCircle } from "lucide-react"
import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { useLanguageStore } from "@/lib/language-store"

interface MissingModelsDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  missingModels: string[]
}

export function MissingModelsDialog({
  open,
  onOpenChange,
  missingModels,
}: MissingModelsDialogProps) {
  const { getTranslation } = useLanguageStore()

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <AlertCircle className="h-5 w-5 text-red-600" />
            <DialogTitle>{getTranslation("missing.models.title")}</DialogTitle>
          </div>
          <DialogDescription>
            {getTranslation("missing.models.description")}
          </DialogDescription>
        </DialogHeader>
        <div className="mt-4">
          <div className="rounded-md bg-red-50 dark:bg-red-900/20 p-4 max-h-64 overflow-auto">
            <ul className="list-disc list-inside space-y-1 text-sm text-red-800 dark:text-red-200">
              {missingModels.map((model) => (
                <li key={model} className="font-mono">
                  {model}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="mt-4">
          <Button
            onClick={() => onOpenChange(false)}
            className="w-full"
            variant="outline"
          >
            {getTranslation("continue.anyway")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
